import { useEffect, useState } from "react";

import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/** Set of entity_ids the current user has favorited (empty for guests). */
export const useFavoriteIds = () => {
  const { user } = useAuth();
  const [ids, setIds] = useState(() => new Set());

  useEffect(() => {
    if (!user) {
      setIds(new Set());
      return;
    }
    api
      .get("/favorites/ids")
      .then(({ data }) => setIds(new Set(data.map((f) => f.entity_id))))
      .catch(() => {});
  }, [user]);

  return ids;
};
